import NewPaymentSettings from './NewPaymentSettings'
import Main from './Main'
import PaymentSettings from './PaymentSettings'
import BillingSettings from './MainBillingSettings'
import WebhookSettings from './MainWebhookSettings'
import NfeSettings from './MainNfeSettings'
import ShowPaymentSettings from './ShowPaymentSettings'
import EditPaymentMethodsSettings from './EditPaymentMethodsSettings'
import EditPaymentSettings from './EditPaymentSettings'
import IndexPaymentSettings from './IndexPaymentSettings'

export default [
  { path: '/settings/general', name: 'general', component: Main },
  { path: '/settings/payment_settings', name: 'payment_settings', component: PaymentSettings },
  { path: '/settings/webhook_settings', name: 'webhook_settings', component: WebhookSettings },
  { path: '/settings/payment_settings/index', name: 'payment_settings_index', component: IndexPaymentSettings },
  { path: '/settings/payment_settings/:processor/show', name: 'payment_settings_show', component: ShowPaymentSettings },
  { path: '/settings/payment_settings/:processor/new', name: 'payment_settings_new', component: NewPaymentSettings },
  { path: '/settings/payment_settings/:processor/:method/edit', name: 'edit_payment_settings', component: EditPaymentSettings },
  { path: '/settings/payment_settings/:processor/edit', name: 'edit_payment_methods', component: EditPaymentMethodsSettings, props: true },
  { path: '/settings/billing_settings', name: 'billing_settings', component: BillingSettings },
  { path: '/settings/nfe_settings', name: 'nfe_settings', component: NfeSettings }
]



// WEBPACK FOOTER //
// ./src/app/pages/settings/routes.js